// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { MysqlserviceService } from "src/app/services/mysqlService/mysqlservice.service";

export const environment = {

  production: false,
  swapspace : {
    baseapi:'https://api.swapspace.co/api/v2',
    APIkey:'52d609f5e2a7a7d2c93224cabf46221482478c8dabe2803c48002da4e2c1d1b8333a20bb2e751aecf8'
  },
  binance : {
    baseapi : 'https://api.binance.com/api/v3',
    websocket: 'wss://stream.binance.com:9443/ws'
  },
  index : {
    // baseapi : 'http://localhost:5050'
    baseapi :'https://ngadmnapp.hibiz.app'
    // baseapi : 'https://cotoexapi.cotoex.com'
  }
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
